import { StepTracker } from '@hourly-hds/components';
import { ReactNode } from 'react';
import { StepKey } from '../../data/models/step.model';
import styles from './StepContainer.module.css';

const stepNameMap: Partial<Record<StepKey, string>> = {
  PartnerDetails: 'Complete Partner Details',
  BankAccount: 'Add Bank Account',
  SignDocuments: 'Sign Your Documents',
};

export interface StepTrackerItem {
  key: Partial<StepKey>;
  isCompleted: boolean;
  isDisabled: boolean;
}

interface StepContainerProps {
  children: ReactNode;
  selectedStep: string;
  steps: StepTrackerItem[];
  onClickStep: (key: string) => void;
  disabled?: boolean;
}

const StepContainer = ({
  children,
  selectedStep,
  steps = [],
  onClickStep,
  disabled,
}: StepContainerProps) => {
  return (
    <div className={styles.container}>
      <div className={styles.stepTracker}>
        <StepTracker selected={selectedStep} isDisabled={disabled}>
          {steps.map((step) => (
            <StepTracker.Item
              key={step.key}
              value={step.key}
              isCompleted={step.isCompleted}
              isDisabled={step.isDisabled}
              onClick={() => onClickStep(step.key)}>
              {stepNameMap[step.key]}
            </StepTracker.Item>
          ))}
        </StepTracker>
      </div>

      {children}
    </div>
  );
};

export default StepContainer;
